import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import PageWrapper from "../../shared/PageWrapper";
import DevelopmentNewsPost from "./DevelopmentNewsPost";
import { useParams } from "react-router-dom";

const DevelopmentNewsPostPage: React.FC = () => {
  const { developmentNewsID } = useParams();

  return (
    <CPLAnalytics pageName="Development News Post">
      <PageWrapper title="Development News Post" backTo="/News" data-test-id="development-news-post__back-button">
        <DevelopmentNewsPost developmentNewsID={developmentNewsID!} />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default DevelopmentNewsPostPage;
